import { render, staticRenderFns } from "./communityPublicityManageList.vue?vue&type=template&id=36d24b18&scoped=true"
import script from "./communityPublicityManageList.vue?vue&type=script&lang=js"
export * from "./communityPublicityManageList.vue?vue&type=script&lang=js"
import style0 from "./communityPublicityManageList.vue?vue&type=style&index=0&id=36d24b18&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_a6c7c6c484daeff6636bea47b922569f/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36d24b18",
  null
  
)

export default component.exports